import React from 'react';
import { styled } from '@compiled/react';
import AKSpinner from '@atlaskit/spinner';

type Props = {
	testId?: string;
};

const Spinner = ({ testId }: Props) => (
	<SpinnerContainer data-test-id={testId} data-testid={testId}>
		<AKSpinner />
	</SpinnerContainer>
);

export default Spinner;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerContainer = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	minHeight: '300px',
});
